export { postFileResponseSchema } from './post-file.schema';
